import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "tabs-row" }
const _hoisted_3 = { class: "tab-label" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tab-content" }
const _hoisted_6 = {
  key: 0,
  class: "tab-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTabs = _resolveComponent("DxTabs")!
  const _component_GridTabParteneri = _resolveComponent("GridTabParteneri")!
  const _component_GridParteneriDetalii = _resolveComponent("GridParteneriDetalii")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["tab-fixed", { 'tab-fixed-active': _ctx.selectedIndex === 0 }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToListTab && _ctx.goToListTab(...args)))
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("span", null, "Parteneri", -1)
      ]))], 2),
      (_ctx.partnerTabs.length > 0)
        ? (_openBlock(), _createBlock(_component_DxTabs, {
            key: 0,
            class: "tabs-scroll",
            "data-source": _ctx.partnerTabs,
            "selected-index": _ctx.selectedIndex - 1,
            "item-template": "tabItem",
            "scrolling-enabled": true,
            "show-nav-buttons": true,
            onOptionChanged: _ctx.onTabChanged
          }, {
            tabItem: _withCtx(({ data, index }) => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(data.text), 1),
                _createElementVNode("span", {
                  class: "tab-close",
                  onClick: _withModifiers(($event: any) => (_ctx.closeTab(index)), ["stop"])
                }, "×", 8, _hoisted_4)
              ])
            ]),
            _: 1
          }, 8, ["data-source", "selected-index", "onOptionChanged"]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createVNode(_component_GridTabParteneri, {
        onSelectPartener: _ctx.onPartenerSelected,
        class: "grid-fill"
      }, null, 8, ["onSelectPartener"])
    ], 512), [
      [_vShow, _ctx.selectedIndex === 0]
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openPartners, (p, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: p.partenerId
      }, [
        (_ctx.selectedIndex === i + 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_GridParteneriDetalii, {
                partener: p.partenerData,
                class: "fill",
                onBack: _ctx.goToListTab
              }, null, 8, ["partener", "onBack"])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}